import { Grid, createTheme, ThemeProvider, CircularProgress, Modal } from "@mui/material";
import { Box } from "@mui/system";
import { useState, useEffect, useCallback, useMemo } from "react";
import "./styles.css";
import Title from "../../components/Dashboard/Title";
import Card from "../../components/Dashboard/Card";
import api from "../../services/ControlPanel";
import Loader from "../../components/pageLoader/loader";
import { ImStatsBars } from "react-icons/im";
import { TeacherClasses } from "../../services/Subject";
import TextField from "@mui/material/TextField";
import { getAccountProfile } from "../../features/auth/authSlice";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import ErrorService from "../../services/errorService";
import LoaderLine from "../../components/LoaderLine";
import dashboardApi from "../../services/dashboard";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { formatNumber } from "../../utils";
import FeedbackModal from "../../components/Feedback/Feedback";
import { useNavigate } from "react-router-dom";

const theme = createTheme({
  palette: {
    primary: {
      main: "#671E78",
    },
  },
});

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { lg: 800, xs: 400 },
  height: "300px",
  borderRadius: "10px",
  border: "1px solid #671E78",
  p: 4,
};

const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [departId, setDepartId] = useState("");
  const [cateName, setCateName] = useState("");
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState([]);
  const [selectedSchools, setSelectedSchools] = useState([]);
  const [classes, setClasses] = useState([]);
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [allDashboardCounts, setAllDashboardCounts] = useState([]);
  const { accessObj, user, admToken, isLoading } = useSelector(
    (state) => state.auth
  );
  const [modalData, setModalData] = useState({
    isOpen: false,
    isLoading: false,
    item: null
  });

  const getClasses = useCallback(
    async (id) => {
      try {
        const res = await TeacherClasses(admToken, id);
        

        if (res.status && res.statusCode === 2) {
          setClasses(res.data);
        }
        if (!res.status) {
          ErrorService.displayErrorAlert(res);
        }

        if (res.status === 400 || res.status === 500) {
          ErrorService.displayErrorAlert(res.data);
        }
      } catch (error) {
        setLoading(false);
        console.log(error);
      }
    },
    [admToken]
  );

  const assignDefaultSchool = useCallback(
    async (id) => {
      toast.info("Please wait...");
      try {
        const res = await api.assignDefaultSchoolToStaff(
          admToken,
          id,
          user.staffId
        );
        if (res.status === true && res.statusCode === 2) {
    
          toast.success(res.message);
          dispatch(getAccountProfile(admToken));
          getClasses(id);
        }

        if (res.status === 400 || res.status === 500 || res.status === false) {
          ErrorService.displayErrorAlert(res);
        }
      } catch (error) {
        toast.error("An Error Occurred");
      }
    },
    [admToken, dispatch, getClasses, user.staffId]
  );

  const assignDefaultClass = useCallback(
    async (id) => {
      toast.info("Please wait...");
      try {
        const res = await api.assignDefaultClassToStaff(
          admToken,
          user.schoolId,
          user.staffId,
          id
        );
        
        if (res.status === true && res.statusCode === 2) {
          toast.success(res.message);
          dispatch(getAccountProfile(admToken));
        }

        if (res.status === 400 || res.status === 500 || res.status === false) {
          ErrorService.displayErrorAlert(res);
        }
      } catch (error) {
        toast.error("An Error Occurred");
      }
    },
    [admToken, dispatch, user.schoolId, user.staffId]
  );
  const getSelectedSchoolFunc = useCallback(async () => {
    try {
      const res = await api.getSelectedSchool(
        admToken,
        user.phoneNumber,
        accessObj?.privileges?.some((obj) => obj.id === 1) ? 1 : 2
      );
      if (res.status === true && res.statusCode === 2) {
        setSelectedSchools(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  }, [admToken, user.phoneNumber, accessObj?.privileges]);

  const getSelectedDepartFunc = useCallback(async () => {
    try {
      const res = await api.getSelectedDepartment(
        admToken,
        user.phoneNumber,
        accessObj?.privileges?.some((obj) => obj.id === 1) ? 1 : 3,
        user.schoolId
      );
      console.log("selectedDepartments", res.data);
      if (res.status === true && res.statusCode === 2) {
        setSelectedDepartments(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  }, [admToken, user.phoneNumber, user.schoolId, accessObj?.privileges]);

  const getDepartmentDashboardCount = useCallback(
    async (id) => {
      try {
        setLoading(true);
        const res = await api.dashboardCount(admToken, user.phoneNumber, id);
        
        if (res.status && res.statusCode === 2) {
          if (res.data.length === 0) {
            toast.error("No Dashboard Stats Assigned To You At The Moment");
            setDepartId("");
            setCateName("");
          }
        }
        if (!res.status && res.statusCode === 6) {
          toast.error(res.message);
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);

        console.log(error);
      }
    },
    [user, admToken]
  );

  const getDashboardCount = useCallback(
    async (id) => {
      try {
        setLoading(true);
        const res = await dashboardApi.getDashboardCount(
          admToken,
          id,
          user.schoolId
        );
        console.log("dashboardCount", res.data);
        if (res.data.status && res.data.statusCode === 2) {
          setAllDashboardCounts(res.data.data);
          setStats(res?.data.data);
          if (res?.data?.data.length === 0) {
            toast.error("No Dashboard Stats Assigned To You At The Moment");
            setDepartId("");
            setCateName("");
          }
        }
        if (!res.data.status && res.data.statusCode === 6) {
          toast.error(res.data.message);
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.log(error);
      }
    },
    [admToken, user.schoolId]
  );

  useEffect(() => {
    getSelectedSchoolFunc();
    getSelectedDepartFunc();
    getClasses(user.schoolId);
  }, [getSelectedSchoolFunc, getSelectedDepartFunc, getClasses, user.schoolId]);

  return (
    <>
      <ThemeProvider theme={theme}>
        <Box sx={{}}>
          <Title />
          {isLoading && <LoaderLine />}
          {selectedSchools.length > 0 && (
            <Box sx={{ display: "", marginTop: "0.3rem" }}>
              <Grid container spacing={2}>
                <Grid item lg={3} xs={12}>
                  <FormControl fullWidth>
                    <label htmlFor="">Choose School</label>

                    <Select
                      sx={{ fontFamily: "Gilroy-Regular" }}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      variant="outlined"
                      size="small"
                      value={user.schoolId.toString()}
                      onChange={(e) => {
                        assignDefaultSchool(e.target.value);
                        // setSchool(e.target.value);
                      }}
                    >
                      {selectedSchools.length > 0 &&
                        selectedSchools.map((item, index) => (
                          <MenuItem
                            key={index}
                            sx={{ fontFamily: "Gilroy-Regular" }}
                            value={item.schoolid}
                          >
                            {item.schoolname}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item lg={3} xs={12}>
                  <FormControl fullWidth>
                    <label htmlFor="">Choose Department</label>
                    <Select
                      sx={{ fontFamily: "Gilroy-Regular" }}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      variant="outlined"
                      size="small"
                      value={departId.toString()}
                      onChange={(e) => {
                        setDepartId(e.target.value);
                        console.log("selectedDepartments", e.target.value);
                        if (e.target.value === "") {
                          setSelectedDepartments([]);
                        }
                        let name = selectedDepartments.find(
                          (item) => e.target.value === item.departmentId
                        ).categoryName;

                        setCateName(name);
                        getDepartmentDashboardCount(e.target.value);
                        getDashboardCount(e.target.value);
                      }}
                    >
                      <MenuItem
                        sx={{ fontFamily: "Gilroy-Regular" }}
                        value={""}
                      >
                        Please Select Department
                      </MenuItem>
                      {selectedDepartments.map((item, index) => (
                        <MenuItem
                          sx={{ fontFamily: "Gilroy-Regular" }}
                          value={item.departmentId}
                          key={index}
                        >
                          {item.departmentName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                {cateName.length > 0 && (
                  <Grid item lg={3} xs={12}>
                    <FormControl fullWidth>
                      <label htmlFor="">Category</label>

                      <TextField
                        type="text"
                        value={cateName}
                        id="outlined-basic"
                        variant="outlined"
                        sx={{
                          fontFamily: "Gilroy-Regular",
                        }}
                        labelId="demo-simple-select-label"
                        size="small"
                        disabled
                      />
                    </FormControl>
                  </Grid>
                )}

                {classes.length > 0 && (
                  <Grid item lg={3} xs={12}>
                    <FormControl fullWidth>
                      <label htmlFor="">Choose Class</label>

                      <Select
                        sx={{ fontFamily: "Gilroy-Regular" }}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        variant="outlined"
                        size="small"
                        value={user.classId.toString()}
                        onChange={(e) => {
                          assignDefaultClass(e.target.value);
                        }}
                      >
                        {classes.length > 0 &&
                          classes.map((item, index) => (
                            <MenuItem
                              key={index}
                              sx={{
                                fontFamily: "Gilroy-Regular",
                                fontWeight: 'bold'
                              }}
                              value={item.classId}
                            >
                              <div className="font-[600]">
                                {item.className} {item.classArm}
                              </div>

                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </Grid>
                )}
              </Grid>
            </Box>
          )}
          {loading ? (
            <Loader />
          ) : (
            <Grid container spacing={2} mt={3}>
              {selectedDepartments.length > 0 &&
                stats.map((item, index) => (
                  <Grid item lg={4} sm={6} xs={12} key={index}>
                    <div
                      className="cursor-pointer h-full"
                      onClick={() => {
                        setModalData({
                          isOpen: true,
                          isLoading: true,
                          item: {
                            ...item,
                            type: item.name.replace(/\s+/g, '')
                          }
                        })
                      }}
                    >
                      <Card
                        label={item.name}
                        value={formatNumber(item.count)}
                        icon={<ImStatsBars />}
                      />
                    </div>
                  </Grid>
                ))}
            </Grid>
          )}
        </Box>
      </ThemeProvider>
      <DynamicModal
        modalData={modalData}
        setModalData={setModalData}
        admToken={admToken}
        user={user}
      />
    </>
  );
};

const DynamicModal = ({ modalData, setModalData, admToken, user }) => {
  const [apiData, setApiData] = useState(null);
  const [birthdayFilters, setBirthdayFilters] = useState({
    month: new Date().getMonth() + 1,
    day: new Date().getDate()
  });
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10
  });

  const handleBirthdayFilterChange = (e) => {
    const { name, value } = e.target;
    setBirthdayFilters(prev => ({
      ...prev,
      [name]: value ? parseInt(value) : ''
    }));
  };

  const endpointMap = useMemo(() => ({
    'Classes': (page = 1, size = 10) => api.getDashboardClass(admToken, user.schoolId, page, size),
    'Subjects': (page = 1, size = 10) => api.getDashboardSubject(admToken, user.classId, user.schoolId, page, size),
    'RegisteredSchools': (page = 1, size = 10) => api.getDashboardRegisteredSchool(admToken, user.schoolId, page, size),
    'PendingAdmissions': (page = 1, size = 10) => api.getDashboardPendingAdmission(admToken, user.schoolId, page, size),
    'StudentPopulation': (page = 1, size = 10) => api.getDashboardActivePopulation(admToken, user.schoolId, page, size),
    'InActiveStudentPopulation': (page = 1, size = 10) => api.getDashboardInActivePopulation(admToken, user.schoolId, page, size),
    'ParentPopulation': (page = 1, size = 10) => api.getDashboardActiveParentPopulation(admToken, user.schoolId, page, size),
    'InActiveParentPopulation': (page = 1, size = 10) => api.getDashboardInActiveParentPopulation(admToken, user.schoolId, page, size),
    'Hostels': (page = 1, size = 10) => api.getDashboardHostels(admToken, user.schoolId, page, size),
    'Department': (page = 1, size = 10) => api.getDashboardGetDepartments(admToken, user.schoolId, page, size),
    'TeachingStaff': (page = 1, size = 10) => api.getDashboardGetTeachingStaffs(admToken, user.schoolId, page, size),
    'Non-TeachingStaff': (page = 1, size = 10) => api.getDashboardGetNonTeachingStaffs(admToken, user.schoolId, page, size),
    'Roles': (page = 1, size = 10) => api.getDashboardGetRoles(admToken, user.schoolId, page, size),
    'StaffwithRoles': (page = 1, size = 10) => api.getDashboardGetStaffsRoles(admToken, user.schoolId, page, size),
    'StaffwithoutRoles': (page = 1, size = 10) => api.getDashboardGetStaffsWithoutRoles(admToken, user.schoolId, page, size),
    'Classworks': (page = 1, size = 10) => api.getDashboardGetClassworks(admToken, user.schoolId, user.classId),
    'SubmittedClassworks': (page = 1, size = 10) => api.getDashboardGetGetSubmittedClassworks(admToken, user.schoolId, user.classId, page, size),
    'Assignment': (page = 1, size = 10) => api.getDashboardGetAssignments(admToken, user.schoolId, user.classId, page, size),
    'SubmittedAssignments': (page = 1, size = 10) => api.getDashboardGetGetSubmittedAssignments(admToken, user.schoolId, user.classId, page, size),
    'StaffBirthdays': (page = 1, size = 10) => api.getDashboardGetStaffsDOB(
      admToken,
      birthdayFilters.day,
      birthdayFilters.month,
      user.classId,
      user.schoolId,
      page,
      size,
    ),
    "Feedbacks/Complaints": (page = 1, size = 10) => dashboardApi.getFeedbacks(
      admToken,
      '',
      size,
      page,
      user.schoolId
    ),

  }), [admToken, user.schoolId, user.classId, birthdayFilters.month, birthdayFilters.day]);

  const getEndpoint = (type) => {
    if (endpointMap[type]) return endpointMap[type];

    const foundKey = Object.keys(endpointMap).find(
      key => key.toLowerCase() === type.toLowerCase()
    );
    console.log(foundKey)
    console.log(endpointMap[type])

    return foundKey ? endpointMap[foundKey] : endpointMap['Classes'];
  };

  useEffect(() => {
    if (!modalData.item?.type) return;

    const fetchData = async () => {
      try {
        setModalData(prev => ({ ...prev, isLoading: true }));
        setApiData(null);
        const apiCall = getEndpoint(modalData.item.type);
        const response = await apiCall(pagination.page, pagination.pageSize);

        const res = response?.data?.statusCode ? response.data : response;

        if (res?.status && res.statusCode === 2) {
          setApiData(res.data);
        } else {
          throw new Error(res?.message || 'Failed to load data');
        }
      } catch (error) {
        console.error('API Error:', error);
        toast.error(error.message);
        setApiData({ error: error.message });
      } finally {
        setModalData(prev => ({ ...prev, isLoading: false }));
      }
    };

    fetchData();
  }, [modalData.item, endpointMap, pagination.page, pagination.pageSize]);

  useEffect(() => {
    setPagination({
      page: 1,
      pageSize: 10
    });
    setApiData(null);
  }, [modalData.item?.type]);

  const renderPagination = () => {
    return (
      <>
        <div className="flex items-center justify-between px-3 py-2 bg-gray-50 rounded-lg">
          <div className="py-3 px-4 bg-gray-50 rounded-lg text-sm text-gray-600">
            Showing {(apiData.data.currentRecordCount) * (apiData.data.currentPage)} of {apiData.data.totalRecordCount} (Page {apiData.data.currentPage} of {apiData.data.totalPages})
          </div>
          <div className="flex-1 flex justify-between items-center">
            <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-center">
              <div>
                <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
                  {Array.from({ length: Math.min(5, apiData.data.totalPages) }, (_, i) => {
                    const pageNum = Math.max(1, Math.min(
                      apiData.data.totalPages - 4,
                      pagination.page - 2
                    )) + i;

                    return (
                      <button
                        key={pageNum}
                        onClick={() => setPagination(prev => ({ ...prev, page: pageNum }))}
                        className={`relative inline-flex items-center px-3 py-1 border text-sm font-medium ${pageNum === pagination.page
                          ? 'z-10 bg-blue-50 border-blue-500 text-blue-600'
                          : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50'
                          }`}
                      >
                        {pageNum}
                      </button>
                    );
                  })}
                </nav>
              </div>
            </div>
            <button
              onClick={() => setPagination(prev => ({
                ...prev,
                page: Math.max(1, prev.page - 1)
              }))}
              disabled={pagination.page === 1}
              className={`relative inline-flex items-center px-3 py-1 border mr-1 border-gray-300 text-sm font-medium rounded-md ${pagination.page === 1
                ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                : 'bg-white text-gray-700 hover:bg-gray-50'
                }`}
            >
              Pre
            </button>
            <button
              onClick={() => setPagination(prev => ({
                ...prev,
                page: Math.min(apiData.data.totalPages, prev.page + 1)
              }))}
              disabled={pagination.page === apiData.data.totalPages}
              className={`relative inline-flex items-center px-3 py-1 border border-gray-300 text-sm font-medium rounded-md ${pagination.page === apiData.data.totalPages
                ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                : 'bg-white text-gray-700 hover:bg-gray-50'
                }`}
            >
              Nex
            </button>
          </div>
        </div>
      </>
    )
  }

  const renderContent = () => {
    if (apiData?.error) {
      return (
        <div className="text-red-500 p-4 bg-red-50 rounded-lg">
          Error: {apiData.error}
        </div>
      );
    }

    if (!apiData) return null;

    if (modalData.item?.type === 'Classes' && apiData?.data?.records) {
      return (
        <div className="space-y-6">
          {apiData?.data?.records?.length === 0 ? (
            <div className="text-center py-8 bg-gray-50 rounded-lg">
              <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <h4 className="mt-2 text-lg font-medium text-gray-900">No Classes Found</h4>
              <p className="mt-1 text-sm text-gray-500">There are currently no classes registered in the system.</p>
            </div>
          ) : (
            <>
              <div className="space-y-4 max-h-[60vh] overflow-y-auto pr-2">
                {apiData?.data?.records?.map((record, index) => (
                  <div key={index} className="border border-gray-200 rounded-lg p-6 hover:bg-gray-50 transition-colors shadow-sm">
                    <div className="flex items-start justify-between">
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center space-x-4">
                          <div className="flex-shrink-0 bg-purple-100 text-purple-800 rounded-lg p-3">
                            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                            </svg>
                          </div>
                          <div className="flex-1">
                            <div className="flex items-center justify-between">
                              <div>
                                <h3 className="text-lg font-medium text-gray-900">
                                  {record.className} {record.classArm}
                                </h3>
                                <p className="text-sm text-gray-500 mt-1">{record.schoolName}</p>
                              </div>
                              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                Class Order: {record.classOrder}
                              </span>
                            </div>

                            <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
                              <div className="flex items-start">
                                <svg className="flex-shrink-0 h-5 w-5 text-gray-400 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                  <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                                </svg>
                                <div className="ml-3">
                                  <p className="text-sm text-gray-500">Class Teacher</p>
                                  <p className="text-sm font-medium text-gray-900">
                                    {record.staffname || 'Not assigned'}
                                  </p>
                                </div>
                              </div>

                              <div className="flex items-start">
                                <svg className="flex-shrink-0 h-5 w-5 text-gray-400 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                  <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                                </svg>
                                <div className="ml-3">
                                  <p className="text-sm text-gray-500">Year Tutor</p>
                                  <p className="text-sm font-medium text-gray-900">
                                    {record.yearTutor ? `Tutor ID: ${record.yearTutor}` : 'Not assigned'}
                                  </p>
                                </div>
                              </div>

                              <div className="flex items-start">
                                <svg className="flex-shrink-0 h-5 w-5 text-gray-400 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                  <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                                </svg>
                                <div className="ml-3">
                                  <p className="text-sm text-gray-500">Category</p>
                                  <p className="text-sm font-medium text-gray-900">
                                    {record.category || record.cat || 'Not specified'}
                                  </p>
                                </div>
                              </div>

                              <div className="flex items-start">
                                <svg className="flex-shrink-0 h-5 w-5 text-gray-400 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                  <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
                                </svg>
                                <div className="ml-3">
                                  <p className="text-sm text-gray-500">Class For</p>
                                  <p className="text-sm font-medium text-gray-900">
                                    {record.classFor || 'All students'}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {renderPagination()}
            </>
          )}
        </div>
      );
    }
    if (modalData.item?.type === 'Assignment' && apiData?.data?.records) {
      return (
        <div className="modal space-y-6">
          {apiData?.data?.records?.length === 0 ? (
            <div className="text-center py-8 bg-gray-50 rounded-lg">
              <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <h4 className="mt-2 text-lg font-medium text-gray-900">No {modalData.item?.type} found</h4>
            </div>
          ) : (
            <>
              <div className="space-y-6 max-h-[60vh] overflow-y-auto pr-2">
                {apiData?.data?.records?.map((record, index) => (
                  <div key={index} className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 transition-colors">
                    <div className="flex justify-between items-start">
                      <div>
                        <h4 className="font-bold text-purple-800">
                          {record.assignmentSubname} - {record.className} ({record.classCarm})
                        </h4>
                        <p className="font-medium mt-1">{record.assignmentTitle}</p>
                      </div>
                      <span className={`px-2 py-1 rounded text-xs ${record.assignmentStatus === 'Deactivate'
                        ? 'bg-red-100 text-red-800'
                        : 'bg-green-100 text-green-800'
                        }`}>
                        {record.assignmentStatus}
                      </span>
                    </div>

                    <div className="mt-2">
                      <p className="text-sm text-gray-600 whitespace-pre-line">
                        {record.assignmentDescription}
                      </p>
                    </div>

                    <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm">
                      <div>
                        <span className="font-medium">Teacher:</span> {[
                          record.firstName?.trim(),
                          record.middleName?.trim(),
                          record.lastName?.trim()
                        ].filter(name => name && name !== 'x').join(' ')}
                      </div>
                      <div>
                        <span className="font-medium">School:</span> {record.schoolName}
                      </div>
                      <div>
                        <span className="font-medium">Score:</span> {record.assignmentScore}
                      </div>
                      <div>
                        <span className="font-medium">Posted:</span> {new Date(record.assignmentPostDate).toLocaleDateString('en-US', {
                          year: 'numeric',
                          month: 'short',
                          day: 'numeric'
                        })}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {renderPagination()}
            </>
          )}
        </div>
      );
    }
    if (modalData.item?.type === 'Classes' && apiData?.data?.records) {
      return (
        <div className="modal space-y-6">
          {apiData?.data?.records?.length === 0 ? (
            <div className="text-center py-8 bg-gray-50 rounded-lg">
              <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <h4 className="mt-2 text-lg font-medium text-gray-900">No {modalData.item?.type} found</h4>
            </div>
          ) : (
            <>
              <div className="space-y-6 max-h-[60vh] overflow-y-auto pr-2">
                {apiData?.data?.records?.map((record, index) => (
                  <div key={index} className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 transition-colors">
                  </div>
                ))}
              </div>
              {renderPagination()}
            </>
          )}
        </div>
      );
    }
    if (modalData.item?.type === 'Subjects' && apiData?.data?.records) {
      return (
        <div className="modal space-y-6">
          {apiData?.data?.records?.length === 0 ? (
            <div className="text-center py-8 bg-gray-50 rounded-lg">
              <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <h4 className="mt-2 text-lg font-medium text-gray-900">No subjects found</h4>
              <p className="mt-1 text-gray-500">There are currently no subjects available.</p>
            </div>
          ) : (
            <>
              <div className="space-y-4 max-h-[60vh] overflow-y-auto pr-2">
                {apiData?.data?.records?.map((subject, index) => (
                  <div key={index} className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 transition-colors">
                    <div className="flex justify-between items-start">
                      <div>
                        <h4 className="font-bold text-purple-800">
                          {subject.subjectName} ({subject.subjectShort})
                        </h4>
                        <div className="flex items-center space-x-2 mt-1 text-sm">
                          {subject.section && (
                            <span className="bg-blue-100 text-blue-800 px-2 py-0.5 rounded">
                              Section: {subject.section}
                            </span>
                          )}
                          {subject.category && (
                            <span className="bg-green-100 text-green-800 px-2 py-0.5 rounded">
                              Category: {subject.category}
                            </span>
                          )}
                        </div>
                      </div>
                      {subject.department && (
                        <span className="bg-purple-100 text-purple-800 px-2 py-1 rounded text-xs">
                          {subject.department}
                        </span>
                      )}
                    </div>

                    <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm">
                      <div>
                        <span className="font-medium">Assigned Teacher:</span> {subject.staffName || 'Not assigned'}
                      </div>
                      <div>
                        <span className="font-medium">School:</span> {subject.schoolname}
                      </div>
                      {subject.unit && (
                        <div>
                          <span className="font-medium">Unit:</span> {subject.unit}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              {renderPagination()}
            </>
          )}
        </div>
      );
    }
    if (modalData.item?.type === 'PendingAdmissions' && apiData?.data) {
      return (
        <div className="space-y-6">
          {apiData?.data?.length === 0 ? (
            <div className="text-center py-8 bg-gray-50 rounded-lg">
              <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <h4 className="mt-2 text-lg font-medium text-gray-900">No Pending Admissions</h4>
              <p className="mt-1 text-sm text-gray-500">There are currently no admission requests awaiting approval.</p>
            </div>
          ) : (
            <>
              <div className="space-y-4 max-h-[60vh] overflow-y-auto pr-2">
                {apiData?.data.map((record, index) => (
                  <div key={index} className="border border-gray-200 rounded-lg p-6 hover:bg-gray-50 transition-colors shadow-sm">
                    <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6">
                      <div className="flex-1 min-w-0">
                        <div className="flex items-start space-x-4">
                          <div className="flex-shrink-0 bg-blue-100 text-blue-800 rounded-lg p-3">
                            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                            </svg>
                          </div>
                          <div className="flex-1">
                            <div className="flex items-center justify-between">
                              <h3 className="text-lg font-medium text-gray-900">
                                {record.lName} {record.fName} {record.mName}
                              </h3>
                              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                                Pending
                              </span>
                            </div>
                            <p className="mt-1 text-sm text-gray-500">{record.schoolname}</p>

                            <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-4">
                              <div className="flex items-start">
                                <svg className="flex-shrink-0 h-5 w-5 text-gray-400 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                  <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                                </svg>
                                <div className="ml-3">
                                  <p className="text-sm text-gray-500">Application Date</p>
                                  <p className="text-sm font-medium text-gray-900">
                                    {new Date(record.createdDate).toLocaleDateString()}
                                  </p>
                                </div>
                              </div>

                              <div className="flex items-start">
                                <svg className="flex-shrink-0 h-5 w-5 text-gray-400 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                                </svg>
                                <div className="ml-3">
                                  <p className="text-sm text-gray-500">Email</p>
                                  <p className="text-sm font-medium text-gray-900 break-all">
                                    {record.email || 'Not provided'}
                                  </p>
                                </div>
                              </div>

                              <div className="flex items-start">
                                <svg className="flex-shrink-0 h-5 w-5 text-gray-400 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                                </svg>
                                <div className="ml-3">
                                  <p className="text-sm text-gray-500">Phone</p>
                                  <p className="text-sm font-medium text-gray-900">
                                    {record.phoneNumber || 'Not provided'}
                                  </p>
                                </div>
                              </div>

                              <div className="flex items-start">
                                <svg className="flex-shrink-0 h-5 w-5 text-gray-400 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                  <path fillRule="evenodd" d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                                </svg>
                                <div className="ml-3">
                                  <p className="text-sm text-gray-500">Payment Method</p>
                                  <p className="text-sm font-medium text-gray-900">
                                    {record.paymentMethod || 'Not specified'}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {renderPagination()}
            </>
          )}
        </div>
      );
    }
    if (modalData.item?.type === 'StudentPopulation' && apiData?.data?.records) {
      return (
        <div className="modal space-y-6">
          {apiData?.data?.records?.length === 0 ? (
            <div className="text-center py-8 bg-gray-50 rounded-lg">
              <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <h4 className="mt-2 text-lg font-medium text-gray-900">No Active Student Population found</h4>
            </div>
          ) : (
            <>
              <div className="space-y-6 max-h-[60vh] overflow-y-auto pr-2">
                {apiData?.data?.records.map((record, index) => (
                  <div key={index} className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 transition-colors">
                    <div className="flex items-center space-x-4">
                      <div className="flex-shrink-0">
                        <img
                          className="h-12 w-12 rounded-full object-cover"
                          src={record.profileImagePath}
                          alt={`${record.firstName} ${record.lastName}`}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "https://via.placeholder.com/48";
                          }}
                        />
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="flex justify-between items-start">
                          <div>
                            <h3 className="text-sm font-medium text-gray-900 truncate">
                              {record.lastName} {record.firstName} {record.otherName}
                            </h3>
                            <p className="text-sm text-gray-500 truncate">
                              {record.cName} {record.cArm}
                            </p>
                          </div>
                          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                            {record.admission_no || "N/A"}
                          </span>
                        </div>
                        <div className="mt-1 flex flex-col sm:flex-row sm:flex-wrap sm:space-x-4">
                          <div className="flex items-center text-sm text-gray-500">
                            <svg className="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                              <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                              <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                            </svg>
                            {record.email}
                          </div>
                          <div className="flex items-center text-sm text-gray-500">
                            <svg className="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                              <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                            </svg>
                            {record.phoneNumber}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {renderPagination()}
            </>
          )}
        </div>
      );
    }
    if (modalData.item?.type === 'InActiveStudentPopulation' && apiData?.data?.records) {
      return (
        <div className="space-y-6">
          {apiData?.data?.records?.length === 0 ? (
            <div className="text-center py-8 bg-gray-50 rounded-lg">
              <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <h4 className="mt-2 text-lg font-medium text-gray-900">No Inactive Students Found</h4>
              <p className="mt-1 text-sm text-gray-500">There are currently no inactive students in the system.</p>
            </div>
          ) : (
            <>
              <div className="space-y-6 max-h-[60vh] overflow-y-auto pr-2">
                {apiData?.data?.records.map((record, index) => (
                  <div key={index} className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 transition-colors">
                    <div className="flex items-center space-x-4">
                      <div className="flex-shrink-0">
                        <img
                          className="h-12 w-12 rounded-full object-cover"
                          src={record.profileImagePath}
                          alt={`${record.firstName} ${record.lastName}`}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "https://via.placeholder.com/48";
                          }}
                        />
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="flex justify-between items-start">
                          <div>
                            <h3 className="text-sm font-medium text-gray-900 truncate">
                              {record.lastName} {record.firstName} {record.otherName}
                            </h3>
                            <div className="flex items-center mt-1">
                              <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800 mr-2">
                                {record.cName} {record.cArm}
                              </span>
                              <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-red-100 text-red-800">
                                Inactive
                              </span>
                            </div>
                          </div>
                          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
                            {record.admission_no || "N/A"}
                          </span>
                        </div>
                        <div className="mt-2 flex flex-col sm:flex-row sm:flex-wrap sm:space-x-4">
                          <div className="flex items-center text-sm text-gray-500 mb-2 sm:mb-0">
                            <svg className="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                              <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                              <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                            </svg>
                            {record.email}
                          </div>
                          <div className="flex items-center text-sm text-gray-500">
                            <svg className="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                              <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                            </svg>
                            {record.phoneNumber}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {renderPagination()}
            </>
          )}
        </div>
      );
    }
    if (modalData.item?.type === 'InActiveParentPopulation' && apiData?.data?.records) {
      return (
        <div className="space-y-6">
          {apiData?.data?.records?.length === 0 ? (
            <div className="text-center py-8 bg-gray-50 rounded-lg">
              <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <h4 className="mt-2 text-lg font-medium text-gray-900">No Parents Found</h4>
              <p className="mt-1 text-sm text-gray-500">There are currently no parent records in the system.</p>
            </div>
          ) : (
            <>
              <div className="space-y-4 max-h-[60vh] overflow-y-auto pr-2">
                {apiData?.data?.records.map((record, index) => (
                  <div key={index} className="border border-gray-200 rounded-lg p-6 hover:bg-gray-50 transition-colors shadow-sm">
                    <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6">
                      <div className="flex-1 min-w-0">
                        <div className="flex items-start space-x-4">
                          <div className="flex-shrink-0">
                            <img
                              className="h-16 w-16 rounded-full object-cover"
                              src={record.parentProfileImagePath || "https://via.placeholder.com/64"}
                              alt={record.parentFullName}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "https://via.placeholder.com/64";
                              }}
                            />
                          </div>
                          <div className="flex-1">
                            <h3 className="text-lg font-medium text-gray-900">{record.parentFullName}</h3>
                            <div className="mt-1 flex items-center">
                              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 mr-2">
                                {record.relationShip || 'Parent'}
                              </span>
                            </div>

                            <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-4">
                              <div className="flex items-start">
                                <svg className="flex-shrink-0 h-5 w-5 text-gray-400 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                                </svg>
                                <div className="ml-3">
                                  <p className="text-sm text-gray-500">Email</p>
                                  <p className="text-sm font-medium text-gray-900 break-all">
                                    {record.email || 'Not provided'}
                                  </p>
                                </div>
                              </div>

                              <div className="flex items-start">
                                <svg className="flex-shrink-0 h-5 w-5 text-gray-400 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                                </svg>
                                <div className="ml-3">
                                  <p className="text-sm text-gray-500">Phone</p>
                                  <p className="text-sm font-medium text-gray-900">
                                    {record.phoneNumber || 'Not provided'}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="border-t md:border-t-0 md:border-l border-gray-200 pt-4 md:pt-0 md:pl-6">
                        <h4 className="text-sm font-medium text-gray-500 mb-3">Student Information</h4>
                        <div className="flex items-start space-x-4">
                          <div className="flex-shrink-0">
                            <img
                              className="h-12 w-12 rounded-full object-cover"
                              src={record.profileImagePath || "https://via.placeholder.com/48"}
                              alt={`${record.firstName} ${record.lastName}`}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "https://via.placeholder.com/48";
                              }}
                            />
                          </div>
                          <div className="flex-1">
                            <h4 className="text-sm font-medium text-gray-900">
                              {record.firstName} {record.middleName} {record.lastName}
                            </h4>
                            <p className="text-sm text-gray-500 mt-1">
                              {record.cName} {record.cArm}
                            </p>
                            <p className="text-xs text-gray-400 mt-1">
                              {record.schoolName}
                            </p>
                            <p className="text-xs text-gray-500 mt-1">
                              Admission: {record.admissionNumber || 'N/A'}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {renderPagination()}
            </>
          )}
        </div>
      );
    }
    if (modalData.item?.type === 'ParentPopulation' && apiData?.data?.records) {
      return (
        <div className="space-y-6">
          {apiData?.data?.records?.length === 0 ? (
            <div className="text-center py-8 bg-gray-50 rounded-lg">
              <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <h4 className="mt-2 text-lg font-medium text-gray-900">No Parents Found</h4>
              <p className="mt-1 text-sm text-gray-500">There are currently no parent records in the system.</p>
            </div>
          ) : (
            <>
              <div className="space-y-4 max-h-[60vh] overflow-y-auto pr-2">
                {apiData?.data?.records.map((record, index) => (
                  <div key={index} className="border border-gray-200 rounded-lg p-6 hover:bg-gray-50 transition-colors shadow-sm">
                    <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6">
                      <div className="flex-1 min-w-0">
                        <div className="flex items-start space-x-4">
                          <div className="flex-shrink-0">
                            <img
                              className="h-16 w-16 rounded-full object-cover"
                              src={record.parentProfileImagePath || "https://via.placeholder.com/64"}
                              alt={record.parentFullName}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "https://via.placeholder.com/64";
                              }}
                            />
                          </div>
                          <div className="flex-1">
                            <h3 className="text-lg font-medium text-gray-900">{record.parentFullName}</h3>
                            <div className="mt-1 flex items-center">
                              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 mr-2">
                                {record.relationShip || 'Parent'}
                              </span>
                            </div>

                            <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-4">
                              <div className="flex items-start">
                                <svg className="flex-shrink-0 h-5 w-5 text-gray-400 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                                </svg>
                                <div className="ml-3">
                                  <p className="text-sm text-gray-500">Email</p>
                                  <p className="text-sm font-medium text-gray-900 break-all">
                                    {record.email || 'Not provided'}
                                  </p>
                                </div>
                              </div>

                              <div className="flex items-start">
                                <svg className="flex-shrink-0 h-5 w-5 text-gray-400 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                                </svg>
                                <div className="ml-3">
                                  <p className="text-sm text-gray-500">Phone</p>
                                  <p className="text-sm font-medium text-gray-900">
                                    {record.phoneNumber || 'Not provided'}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="border-t md:border-t-0 md:border-l border-gray-200 pt-4 md:pt-0 md:pl-6">
                        <h4 className="text-sm font-medium text-gray-500 mb-3">Student Information</h4>
                        <div className="flex items-start space-x-4">
                          <div className="flex-shrink-0">
                            <img
                              className="h-12 w-12 rounded-full object-cover"
                              src={record.profileImagePath || "https://via.placeholder.com/48"}
                              alt={`${record.firstName} ${record.lastName}`}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "https://via.placeholder.com/48";
                              }}
                            />
                          </div>
                          <div className="flex-1">
                            <h4 className="text-sm font-medium text-gray-900">
                              {record.firstName} {record.middleName} {record.lastName}
                            </h4>
                            <p className="text-sm text-gray-500 mt-1">
                              {record.cName} {record.cArm}
                            </p>
                            <p className="text-xs text-gray-400 mt-1">
                              {record.schoolName}
                            </p>
                            <p className="text-xs text-gray-500 mt-1">
                              Admission: {record.admissionNumber || 'N/A'}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {renderPagination()}
            </>
          )}
        </div>
      );
    }
    if (modalData.item?.type === 'InActiveStudentPopulation' && apiData?.data?.records) {
      return (
        <div className="space-y-6">
          {apiData?.data?.records?.length === 0 ? (
            <div className="text-center py-8 bg-gray-50 rounded-lg">
              <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <h4 className="mt-2 text-lg font-medium text-gray-900">No Inactive Students Found</h4>
              <p className="mt-1 text-sm text-gray-500">There are currently no inactive students in the system.</p>
            </div>
          ) : (
            <>
              <div className="space-y-6 max-h-[60vh] overflow-y-auto pr-2">
                {apiData?.data?.records.map((record, index) => (
                  <div key={index} className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 transition-colors">
                    <div className="flex items-center space-x-4">
                      <div className="flex-shrink-0">
                        <img
                          className="h-12 w-12 rounded-full object-cover"
                          src={record.profileImagePath}
                          alt={`${record.firstName} ${record.lastName}`}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "https://via.placeholder.com/48";
                          }}
                        />
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="flex justify-between items-start">
                          <div>
                            <h3 className="text-sm font-medium text-gray-900 truncate">
                              {record.lastName} {record.firstName} {record.otherName}
                            </h3>
                            <div className="flex items-center mt-1">
                              <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800 mr-2">
                                {record.cName} {record.cArm}
                              </span>
                              <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-red-100 text-red-800">
                                Inactive
                              </span>
                            </div>
                          </div>
                          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
                            {record.admission_no || "N/A"}
                          </span>
                        </div>
                        <div className="mt-2 flex flex-col sm:flex-row sm:flex-wrap sm:space-x-4">
                          {record.email && (
                            <div className="flex items-center text-sm text-gray-500 mb-2 sm:mb-0">
                              <svg className="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                              </svg>
                              {record.email}
                            </div>
                          )}
                          {record.phoneNumber && (
                            <div className="flex items-center text-sm text-gray-500">
                              <svg className="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                              </svg>
                              {record.phoneNumber}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      );
    }
    if (modalData.item?.type === 'RegisteredSchools' && apiData?.data?.records) {
      return (
        <div className="space-y-6">
          {apiData?.data?.records?.length === 0 ? (
            <div className="text-center py-8 bg-gray-50 rounded-lg">
              <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <h4 className="mt-2 text-lg font-medium text-gray-900">No Schools Registered</h4>
              <p className="mt-1 text-sm text-gray-500">There are currently no registered schools in the system.</p>
            </div>
          ) : (
            <>
              <div className="space-y-4 max-h-[60vh] overflow-y-auto pr-2">
                {apiData?.data?.records.map((record, index) => (
                  <div key={index} className="border border-gray-200 rounded-lg p-6 hover:bg-gray-50 transition-colors shadow-sm">
                    <div className="flex items-start justify-between">
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center space-x-3">
                          <div className="flex-shrink-0 bg-blue-100 text-blue-800 rounded-lg p-3">
                            <span className="text-lg font-bold">{record.schoolAbrv || record.schoolName.substring(0, 3).toUpperCase()}</span>
                          </div>
                          <div>
                            <h3 className="text-lg font-medium text-gray-900">{record.schoolName}</h3>
                            <p className="text-sm text-gray-500">{record.schoolAdminContact || 'No admin contact specified'}</p>
                          </div>
                        </div>

                        <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
                          <div className="flex items-start">
                            <svg className="flex-shrink-0 h-5 w-5 text-gray-400 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                              <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                              <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                            </svg>
                            <div className="ml-3">
                              <p className="text-sm text-gray-500">Email</p>
                              <p className="text-sm font-medium text-gray-900 break-all">
                                {record.schoolEmail || 'Not provided'}
                              </p>
                            </div>
                          </div>

                          <div className="flex items-start">
                            <svg className="flex-shrink-0 h-5 w-5 text-gray-400 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                              <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                            </svg>
                            <div className="ml-3">
                              <p className="text-sm text-gray-500">Phone</p>
                              <p className="text-sm font-medium text-gray-900">
                                {record.schoolphone || 'Not provided'}
                              </p>
                            </div>
                          </div>

                          <div className="flex items-start">
                            <svg className="flex-shrink-0 h-5 w-5 text-gray-400 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                            </svg>
                            <div className="ml-3">
                              <p className="text-sm text-gray-500">Help Line</p>
                              <p className="text-sm font-medium text-gray-900">
                                {record.helpLine || 'Not provided'}
                              </p>
                            </div>
                          </div>

                          <div className="flex items-start">
                            <svg className="flex-shrink-0 h-5 w-5 text-gray-400 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                            </svg>
                            <div className="ml-3">
                              <p className="text-sm text-gray-500">Social Media</p>
                              <div className="flex space-x-2 mt-1">
                                {record.facebookUrl && (
                                  <a href={record.facebookUrl} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800">
                                    <span className="sr-only">Facebook</span>
                                    <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                                      <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
                                    </svg>
                                  </a>
                                )}
                                {record.twitterUrl && (
                                  <a href={record.twitterUrl} target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-600">
                                    <span className="sr-only">Twitter</span>
                                    <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                                      <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                                    </svg>
                                  </a>
                                )}
                                {record.igUrl && (
                                  <a href={record.igUrl} target="_blank" rel="noopener noreferrer" className="text-pink-600 hover:text-pink-800">
                                    <span className="sr-only">Instagram</span>
                                    <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                                      <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" />
                                    </svg>
                                  </a>
                                )}
                                {(!record.facebookUrl && !record.twitterUrl && !record.igUrl) && (
                                  <span className="text-sm text-gray-500">None provided</span>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {renderPagination()}
            </>
          )}
        </div>
      );
    }
    if (modalData.item?.type === 'Department' && apiData?.data?.records) {
      return (
        <div className="space-y-6">
          {apiData?.data?.records?.length === 0 ? (
            <div className="text-center py-8 bg-gray-50 rounded-lg">
              <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <h4 className="mt-2 text-lg font-medium text-gray-900">No Departments Found</h4>
              <p className="mt-1 text-sm text-gray-500">There are currently no departments registered in the system.</p>
            </div>
          ) : (
            <>
              <div className="space-y-4 max-h-[60vh] overflow-y-auto pr-2">
                {apiData?.data?.records.map((record, index) => (
                  <div key={index} className="border border-gray-200 rounded-lg p-6 hover:bg-gray-50 transition-colors shadow-sm">
                    <div className="flex items-start justify-between">
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center space-x-4">
                          <div className="flex-shrink-0 bg-indigo-100 text-indigo-800 rounded-lg p-3">
                            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                            </svg>
                          </div>
                          <div>
                            <h3 className="text-lg font-medium text-gray-900">{record.departmentName}</h3>
                            <div className="mt-2 flex items-center text-sm text-gray-500">
                              <svg className="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M6 6V5a3 3 0 013-3h2a3 3 0 013 3v1h2a2 2 0 012 2v3.57A22.952 22.952 0 0110 13a22.95 22.95 0 01-8-1.43V8a2 2 0 012-2h2zm2-1a1 1 0 011-1h2a1 1 0 011 1v1H8V5zm1 5a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1z" clipRule="evenodd" />
                                <path d="M2 13.692V16a2 2 0 002 2h12a2 2 0 002-2v-2.308A24.974 24.974 0 0110 15c-2.796 0-5.487-.46-8-1.308z" />
                              </svg>
                              {record.firstName || record.lastName ? (
                                <span>{record?.firstName} {record?.middleName} {record?.lastName}</span>
                              ) : (
                                <span>No department head assigned</span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {renderPagination()}
            </>
          )}
        </div>
      );
    }
    if (modalData.item?.type === 'TeachingStaff' && apiData?.data?.records) {
      return (
        <div className="space-y-6">
          {apiData?.data?.records?.length === 0 ? (
            <div className="text-center py-8 bg-gray-50 rounded-lg">
              <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <h4 className="mt-2 text-lg font-medium text-gray-900">No teaching staff records found</h4>
            </div>
          ) : (
            <>
              <div className="space-y-6 max-h-[60vh] overflow-y-auto pr-2">
                {apiData?.data?.records.map((staff, index) => (
                  <div key={index} className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 transition-colors">
                    <div className="flex items-start space-x-4">
                      <div className="flex-shrink-0">
                        <div className="h-12 w-12 rounded-full bg-purple-100 flex items-center justify-center text-purple-800 font-medium">
                          {staff.firstName.charAt(0)}{staff.lastName.charAt(0)}
                        </div>
                      </div>

                      <div className="flex-1 min-w-0">
                        <div className="flex justify-between items-start">
                          <div>
                            <h4 className="font-bold text-gray-900">
                              {[staff.firstName, staff.middleName, staff.lastName]
                                .filter(name => name && name.trim() !== '')
                                .join(' ')}
                            </h4>
                            {staff.staffNo && staff.staffNo.trim() !== '' && (
                              <p className="text-sm text-gray-500">Staff No: {staff.staffNo.trim()}</p>
                            )}
                          </div>
                          {staff.gender && staff.gender !== 'x' && (
                            <span className={`px-2 py-1 rounded text-xs ${staff.gender === 'Female'
                              ? 'bg-pink-100 text-pink-800'
                              : 'bg-blue-100 text-blue-800'
                              }`}>
                              {staff.gender}
                            </span>
                          )}
                        </div>

                        <div className="mt-2 grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm">
                          <div>
                            <span className="font-medium">Email:</span> {staff.email || 'N/A'}
                          </div>
                          <div>
                            <span className="font-medium">Phone:</span> {staff.phone || 'N/A'}
                          </div>
                          <div className="sm:col-span-2">
                            <span className="font-medium">School:</span> {staff.schoolName}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {renderPagination()}
            </>
          )}
        </div>
      );
    }
    if (modalData.item?.type === 'Non-TeachingStaff' && apiData?.data?.records) {
      return (
        <div className="space-y-6">
          {apiData?.data?.records?.length === 0 ? (
            <div className="text-center py-8 bg-gray-50 rounded-lg">
              <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <h4 className="mt-2 text-lg font-medium text-gray-900">No teaching staff records found</h4>
            </div>
          ) : (
            <>
              <div className="space-y-6 max-h-[60vh] overflow-y-auto pr-2">
                {apiData?.data?.records.map((staff, index) => (
                  <div key={index} className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 transition-colors">
                    <div className="flex items-start space-x-4">
                      <div className="flex-shrink-0">
                        <div className="h-12 w-12 rounded-full bg-purple-100 flex items-center justify-center text-purple-800 font-medium">
                          {staff.firstName.charAt(0)}{staff.lastName.charAt(0)}
                        </div>
                      </div>

                      <div className="flex-1 min-w-0">
                        <div className="flex justify-between items-start">
                          <div>
                            <h4 className="font-bold text-gray-900">
                              {[staff.firstName, staff.middleName, staff.lastName]
                                .filter(name => name && name.trim() !== '')
                                .join(' ')}
                            </h4>
                            {staff.staffNo && staff.staffNo.trim() !== '' && (
                              <p className="text-sm text-gray-500">Staff No: {staff.staffNo.trim()}</p>
                            )}
                          </div>
                          {staff.gender && staff.gender !== 'x' && (
                            <span className={`px-2 py-1 rounded text-xs ${staff.gender === 'Female'
                              ? 'bg-pink-100 text-pink-800'
                              : 'bg-blue-100 text-blue-800'
                              }`}>
                              {staff.gender}
                            </span>
                          )}
                        </div>

                        <div className="mt-2 grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm">
                          <div>
                            <span className="font-medium">Email:</span> {staff.email || 'N/A'}
                          </div>
                          <div>
                            <span className="font-medium">Phone:</span> {staff.phone || 'N/A'}
                          </div>
                          <div className="sm:col-span-2">
                            <span className="font-medium">School:</span> {staff.schoolName}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {renderPagination()}
            </>
          )}
        </div>
      );
    }
    if (modalData.item?.type === 'Hostels' && apiData.data?.records) {
      return (
        <div className="space-y-6">
          {apiData.data.records.length === 0 ? (
            <div className="text-center py-8 bg-gray-50 rounded-lg">
              <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <h4 className="mt-2 text-lg font-medium text-gray-900">No Hostels Available</h4>
              <p className="mt-1 text-sm text-gray-500">There are currently no hostels registered in the system.</p>
            </div>
          ) : (
            <>
              <div className="space-y-4 max-h-[60vh] overflow-y-auto pr-2">
                {apiData.data.records.map((record, index) => (
                  <div key={index} className="border border-gray-200 rounded-lg p-6 hover:bg-gray-50 transition-colors shadow-sm">
                    <div className="flex items-start justify-between">
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center space-x-4">
                          <div className={`flex-shrink-0 rounded-lg p-3 ${record.gender === 'Male' ? 'bg-blue-100 text-blue-800' : 'bg-pink-100 text-pink-800'
                            }`}>
                            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                            </svg>
                          </div>
                          <div className="flex-1">
                            <div className="flex items-center justify-between">
                              <h3 className="text-lg font-medium text-gray-900">{record.hostelName}</h3>
                              <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${record.gender === 'Male' ? 'bg-blue-100 text-blue-800' : 'bg-pink-100 text-pink-800'
                                }`}>
                                {record.gender}
                              </span>
                            </div>
                            <p className="text-sm text-gray-500 mt-1">{record.schoolName}</p>

                            <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-4">
                              <div className="flex items-start">
                                <svg className="flex-shrink-0 h-5 w-5 text-gray-400 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                  <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                                </svg>
                                <div className="ml-3">
                                  <p className="text-sm text-gray-500">Hostel Head</p>
                                  <p className="text-sm font-medium text-gray-900">
                                    {record.firstName || record.lastName ?
                                      `${record.firstName} ${record.middleName} ${record.lastName}` :
                                      'Not assigned'}
                                  </p>
                                </div>
                              </div>

                              <div className="flex items-start">
                                <svg className="flex-shrink-0 h-5 w-5 text-gray-400 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                                </svg>
                                <div className="ml-3">
                                  <p className="text-sm text-gray-500">Contact</p>
                                  <p className="text-sm font-medium text-gray-900">
                                    {record.phone || 'Not provided'}
                                  </p>
                                </div>
                              </div>
                              z-20<div className="flex items-start">
                                <svg className="flex-shrink-0 h-5 w-5 text-gray-400 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                                </svg>
                                <div className="ml-3">
                                  <p className="text-sm text-gray-500">Email</p>
                                  <p className="text-sm font-medium text-gray-900 break-all">
                                    {record.email}
                                  </p>
                                </div>
                              </div>
                              <div className="flex items-start">
                                <svg className="flex-shrink-0 h-5 w-5 text-gray-400 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                                </svg>
                                <div className="ml-3">
                                  <p className="text-sm text-gray-500">Occupancy</p>
                                  <p className="text-sm font-medium text-gray-900">
                                    {record.currentOccupant !== null && record.maxOccupant !== null ?
                                      `${record.currentOccupant}/${record.maxOccupant}` :
                                      'Not specified'}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {renderPagination()}
            </>
          )}
        </div>
      );
    }
    if (modalData.item?.type === 'Roles' && apiData.data?.records) {
      return (
        <div className="space-y-6">
          {apiData.data.records.length === 0 ? (
            <div className="text-center py-8 bg-gray-50 rounded-lg">
              <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <h4 className="mt-2 text-lg font-medium text-gray-900">No Roles to display</h4>
            </div>
          ) : (
            <>
              <div className="space-y-6 max-h-[60vh] overflow-y-auto pr-2">
                {apiData.data.records.map((record, index) => (
                  <div key={index} className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 transition-colors">
                  </div>
                ))}
              </div>
              {renderPagination()}
            </>
          )}
        </div>
      );
    }
    if (modalData.item?.type === 'StaffwithRoles' && apiData.data?.records) {
      return (
        <div className="space-y-6">
          {apiData.data.records.length === 0 ? (
            <div className="text-center py-8 bg-gray-50 rounded-lg">
              <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <h4 className="mt-2 text-lg font-medium text-gray-900">No staff with roles found</h4>
              <p className="mt-1 text-gray-500">There are currently no staff members assigned to roles.</p>
            </div>
          ) : (
            <>
              <div className="space-y-6 max-h-[60vh] overflow-y-auto pr-2">
                {apiData.data.records.map((staff, index) => (
                  <div key={index} className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 transition-colors">
                    <div className="flex items-start space-x-4">
                      <div className="flex-shrink-0">
                        <div className="h-12 w-12 rounded-full bg-purple-100 flex items-center justify-center text-purple-800 font-medium">
                          {staff.firstName.charAt(0)}{staff.lastName.charAt(0)}
                        </div>
                      </div>

                      <div className="flex-1 min-w-0">
                        <div className="flex justify-between items-start">
                          <div>
                            <h4 className="font-bold text-gray-900">
                              {[staff.firstName, staff.middleName, staff.lastName]
                                .filter(name => name && name.trim() !== '')
                                .join(' ')}
                            </h4>
                            <div className="flex flex-wrap gap-2 mt-1">
                              <span className="bg-blue-100 text-blue-800 px-2 py-0.5 rounded text-xs">
                                {staff.roleName}
                              </span>
                              {staff.departmentName && (
                                <span className="bg-green-100 text-green-800 px-2 py-0.5 rounded text-xs">
                                  {staff.departmentName}
                                </span>
                              )}
                              {staff.categoryName && (
                                <span className="bg-yellow-100 text-yellow-800 px-2 py-0.5 rounded text-xs">
                                  {staff.categoryName}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm">
                          <div>
                            <span className="font-medium">Email:</span> {staff.email || 'N/A'}
                          </div>
                          <div>
                            <span className="font-medium">Phone:</span> {staff.phoneNumber || 'N/A'}
                          </div>
                          <div className="sm:col-span-2">
                            <span className="font-medium">School:</span> {staff.schoolName}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {renderPagination()}
            </>
          )}
        </div>
      );
    }
    if (modalData.item?.type === 'StaffwithoutRoles' && apiData?.data?.records) {
      return (
        <div className="space-y-6">
          {apiData?.data?.records.length === 0 ? (
            <div className="text-center py-8 bg-gray-50 rounded-lg">
              <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <h4 className="mt-2 text-lg font-medium text-gray-900">No unassigned staff found</h4>
              <p className="mt-1 text-gray-500">All staff members have assigned roles.</p>
            </div>
          ) : (
            <>
              <div className="space-y-6 max-h-[60vh] overflow-y-auto pr-2">
                {apiData?.data?.records.map((staff, index) => (
                  <div key={index} className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 transition-colors">
                    <div className="flex items-start space-x-4">
                      <div className="flex-shrink-0">
                        <div className="h-12 w-12 rounded-full bg-gray-200 flex items-center justify-center text-gray-700 font-medium">
                          {staff.firstName?.charAt(0)}{staff.lastName?.charAt(0)}
                        </div>
                      </div>

                      <div className="flex-1 min-w-0">
                        <div className="flex justify-between items-start">
                          <div>
                            <h4 className="font-bold text-gray-900">
                              {[staff.firstName, staff.middleName, staff.lastName]
                                .filter(name => name && name.trim() !== '')
                                .join(' ')}
                            </h4>
                            <div className="mt-1">
                              <span className="bg-red-100 text-red-800 px-2 py-0.5 rounded text-xs">
                                No Role Assigned
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm">
                          <div>
                            <span className="font-medium">Email:</span> {staff.email || 'N/A'}
                          </div>
                          <div>
                            <span className="font-medium">Phone:</span> {staff.phoneNumber || 'N/A'}
                          </div>
                          <div className="sm:col-span-2">
                            <span className="font-medium">School:</span> {staff.schoolName}
                          </div>
                          <div>
                            <span className="font-medium">Staff ID:</span> {staff.staffId}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {renderPagination()}
            </>
          )}
        </div>
      );
    }
    if (modalData.item?.type === 'SubmittedAssignments' && apiData?.data?.records) {
      return (
        <div className="space-y-6">
          {apiData?.data?.records?.length === 0 ? (
            <div className="text-center py-8 bg-gray-50 rounded-lg">
              <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <h4 className="mt-2 text-lg font-medium text-gray-900">No Submitted Assignments</h4>
              <p className="mt-1 text-sm text-gray-500">There are currently no submitted assignments to display.</p>
            </div>
          ) : (
            <>
              <div className="space-y-4 max-h-[60vh] overflow-y-auto pr-2">
                {apiData?.data?.records.map((record, index) => (
                  <div key={index} className="border border-gray-200 rounded-lg p-6 hover:bg-gray-50 transition-colors shadow-sm">
                    <div className="flex flex-col md:flex-row md:items-start md:justify-between">
                      <div className="flex-1 min-w-0">
                        <div className="flex items-start space-x-4">
                          <div className="flex-shrink-0 bg-blue-100 text-blue-800 rounded-lg p-3">
                            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                          </div>
                          <div className="flex-1">
                            <div className="flex items-center justify-between">
                              <h3 className="text-lg font-medium text-gray-900">
                                {record.assignmentTitle}
                                {record.assignmentSubname && ` - ${record.assignmentSubname}`}
                              </h3>
                              <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${record.assignmentStatus === 'Submitted' ? 'bg-green-100 text-green-800' :
                                record.assignmentStatus === 'Pending' ? 'bg-yellow-100 text-yellow-800' :
                                  'bg-gray-100 text-gray-800'
                                }`}>
                                {record.assignmentStatus}
                              </span>
                            </div>
                            <p className="mt-1 text-sm text-gray-500">{record.schoolName}</p>

                            <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-4">
                              <div className="flex items-start">
                                <svg className="flex-shrink-0 h-5 w-5 text-gray-400 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                  <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                                </svg>
                                <div className="ml-3">
                                  <p className="text-sm text-gray-500">Posted Date</p>
                                  <p className="text-sm font-medium text-gray-900">
                                    {new Date(record.assignmentPostDate).toLocaleDateString()}
                                  </p>
                                </div>
                              </div>

                              <div className="flex items-start">
                                <svg className="flex-shrink-0 h-5 w-5 text-gray-400 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                                </svg>
                                <div className="ml-3">
                                  <p className="text-sm text-gray-500">Score</p>
                                  <p className="text-sm font-medium text-gray-900">
                                    {record.assignmentScore !== null ? `${record.assignmentScore}%` : 'Not graded'}
                                  </p>
                                </div>
                              </div>

                              <div className="flex items-start">
                                <svg className="flex-shrink-0 h-5 w-5 text-gray-400 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                  <path d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z" />
                                </svg>
                                <div className="ml-3">
                                  <p className="text-sm text-gray-500">Class</p>
                                  <p className="text-sm font-medium text-gray-900">
                                    {record.className} {record.classCarm}
                                  </p>
                                </div>
                              </div>

                              <div className="flex items-start">
                                <svg className="flex-shrink-0 h-5 w-5 text-gray-400 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                  <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                                </svg>
                                <div className="ml-3">
                                  <p className="text-sm text-gray-500">Submitted By</p>
                                  <p className="text-sm font-medium text-gray-900">
                                    {record.firstName} {record.middleName} {record.lastName}
                                  </p>
                                </div>
                              </div>
                            </div>

                            {record.assignmentDescription && (
                              <div className="mt-4">
                                <h4 className="text-sm font-medium text-gray-500">Description</h4>
                                <p className="mt-1 text-sm text-gray-700 whitespace-pre-line">
                                  {record.assignmentDescription}
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {renderPagination()}
            </>
          )}
        </div>
      );
    }
    if (modalData.item?.type === 'SubmittedClassworks' && apiData?.data?.records) {
      return (
        <div className="space-y-6">
          {apiData?.data?.records?.length === 0 ? (
            <div className="text-center py-8 bg-gray-50 rounded-lg">
              <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <h4 className="mt-2 text-lg font-medium text-gray-900">No Submitted Classworks</h4>
              <p className="mt-1 text-sm text-gray-500">There are currently no classwork submissions to display.</p>
            </div>
          ) : (
            <>
              <div className="space-y-4 max-h-[60vh] overflow-y-auto pr-2">
                {apiData?.data?.records.map((record, index) => (
                  <div key={index} className="border border-gray-200 rounded-lg p-6 hover:bg-gray-50 transition-colors shadow-sm">
                    <div className="flex flex-col md:flex-row md:items-start md:justify-between">
                      <div className="flex-1 min-w-0">
                        <div className="flex items-start space-x-4">
                          <div className="flex-shrink-0 bg-indigo-100 text-indigo-800 rounded-lg p-3">
                            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                          </div>
                          <div className="flex-1">
                            <div className="flex items-center justify-between">
                              <h3 className="text-lg font-medium text-gray-900">
                                {record.title}
                                {record.subName && ` - ${record.subName}`}
                              </h3>
                              <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${record.status === 'Submitted' ? 'bg-green-100 text-green-800' :
                                record.status === 'Pending' ? 'bg-yellow-100 text-yellow-800' :
                                  'bg-gray-100 text-gray-800'
                                }`}>
                                {record.status}
                              </span>
                            </div>
                            <p className="mt-1 text-sm text-gray-500">{record.schoolName}</p>

                            <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-4">
                              <div className="flex items-start">
                                <svg className="flex-shrink-0 h-5 w-5 text-gray-400 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                  <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                                </svg>
                                <div className="ml-3">
                                  <p className="text-sm text-gray-500">Posted Date</p>
                                  <p className="text-sm font-medium text-gray-900">
                                    {new Date(record.postDate).toLocaleDateString()}
                                  </p>
                                </div>
                              </div>

                              <div className="flex items-start">
                                <svg className="flex-shrink-0 h-5 w-5 text-gray-400 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                                </svg>
                                <div className="ml-3">
                                  <p className="text-sm text-gray-500">Score</p>
                                  <p className="text-sm font-medium text-gray-900">
                                    {record.score !== null ? `${record.score}%` : 'Not graded'}
                                  </p>
                                </div>
                              </div>

                              <div className="flex items-start">
                                <svg className="flex-shrink-0 h-5 w-5 text-gray-400 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                  <path d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z" />
                                </svg>
                                <div className="ml-3">
                                  <p className="text-sm text-gray-500">Class</p>
                                  <p className="text-sm font-medium text-gray-900">
                                    {record.className} {record.carm}
                                  </p>
                                </div>
                              </div>

                              <div className="flex items-start">
                                <svg className="flex-shrink-0 h-5 w-5 text-gray-400 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                  <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                                </svg>
                                <div className="ml-3">
                                  <p className="text-sm text-gray-500">Submitted By</p>
                                  <p className="text-sm font-medium text-gray-900">
                                    {record.firstName} {record.middleName} {record.lastName}
                                  </p>
                                </div>
                              </div>
                            </div>

                            {record.description && (
                              <div className="mt-4">
                                <h4 className="text-sm font-medium text-gray-500">Description</h4>
                                <p className="mt-1 text-sm text-gray-700 whitespace-pre-line">
                                  {record.description}
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {renderPagination()}
            </>
          )}
        </div>
      );
    }
    if (modalData.item?.type === 'StaffBirthdays' && apiData?.data?.records) {
      return (
        <div className="space-y-4">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div className="flex items-center space-x-2">
              <div className="flex items-center space-x-2 bg-gray-50 p-2 rounded-lg">
                <select
                  name="month"
                  value={birthdayFilters.month}
                  onChange={handleBirthdayFilterChange}
                  className="border border-gray-300 rounded px-2 py-1 text-sm"
                >
                  {Array.from({ length: 12 }, (_, i) => (
                    <option key={i + 1} value={i + 1}>
                      {new Date(0, i).toLocaleString('default', { month: 'long' })}
                    </option>
                  ))}
                </select>

                <select
                  name="day"
                  value={birthdayFilters.day}
                  onChange={handleBirthdayFilterChange}
                  className="border border-gray-300 rounded px-2 py-1 text-sm"
                >
                  {Array.from({ length: 31 }, (_, i) => (
                    <option key={i + 1} value={i + 1}>
                      {i + 1}
                    </option>
                  ))}
                </select>

                <button
                  onClick={() => setModalData(prev => ({ ...prev, item: { ...prev.item } }))}
                  className="bg-purple-600 text-white px-3 py-1 rounded text-sm hover:bg-purple-700 transition-colors"
                >
                  Search
                </button>
              </div>
            </div>
          </div>

          {apiData?.data?.records?.length === 0 ? (
            <div className="text-center py-8 bg-gray-50 rounded-lg">
              <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <h4 className="mt-2 text-lg font-medium text-gray-900">No birthdays found</h4>
              <p className="mt-1 text-gray-500">No staff members have birthdays on {birthdayFilters.month}/{birthdayFilters.day}.</p>
            </div>
          ) : (
            <>
              <div className="space-y-4 max-h-[60vh] overflow-y-auto pr-2">
                {apiData?.data?.records.map((staff, index) => (
                  <div key={index} className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 transition-colors">
                    <div className="flex items-start space-x-4">
                      <div className="flex-shrink-0">
                        <div className="h-12 w-12 rounded-full bg-pink-100 flex items-center justify-center text-pink-800 font-medium">
                          {staff.firstName.charAt(0)}{staff.lastName.charAt(0)}
                        </div>
                      </div>

                      <div className="flex-1 min-w-0">
                        <h4 className="font-bold text-gray-900">
                          {[staff.firstName, staff.middleName, staff.lastName]
                            .filter(name => name && name.trim() !== '')
                            .join(' ')}
                        </h4>

                        <div className="mt-2 grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm">
                          <div>
                            <span className="font-medium">Birthday:</span> {staff.dateOfBirth}
                          </div>
                          <div>
                            <span className="font-medium">School:</span> {staff.schoolName}
                          </div>
                          <div>
                            <span className="font-medium">Email:</span> {staff.email}
                          </div>
                          <div>
                            <span className="font-medium">Phone Number:</span> {staff.phoneNumber}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {renderPagination()}
            </>
          )}
        </div>
      );
    }
    if (modalData.item?.type === 'Feedbacks/Complaints') {
      return (
        <FeedbackModal />
      )
    }

    return (
      <div className="space-y-6">
        {Object.keys(apiData).length === 0 ? (
          <div className="text-center py-8 bg-gray-50 rounded-lg">
            <svg
              className="mx-auto h-12 w-12 text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <h4 className="mt-2 text-lg font-medium text-gray-900">
              No data available
            </h4>
            <p className="mt-1 text-gray-500">
              There is currently no data to display for this section.
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {Object.entries(apiData) && (
              <div className="text-center py-8 bg-gray-50 rounded-lg">
                <svg
                  className="mx-auto h-12 w-12 text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <h4 className="mt-2 text-lg font-medium text-gray-900">
                  No data available
                </h4>
                <p className="mt-1 text-gray-500">
                  There is currently no data to display for this section.
                </p>
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  return (
    <Modal
      open={modalData.isOpen}
      onClose={() => setModalData({ isOpen: false, item: null })}
      sx={{ zIndex: 1350 }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "#fff",
          borderRadius: "12px",
          p: 4,
          width: "95%",
          maxWidth: "900px",
          maxHeight: "90vh",
          overflowY: "auto",
          border: "1px solid #891e78",
          boxShadow: 24,
        }}
      >
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">{modalData.item?.name || 'Details'}: {formatNumber(modalData.item?.count || 0)}</h2>
          <button
            onClick={() => setModalData({ isOpen: false, item: null })}
            className="p-1 hover:bg-gray-100 rounded-full"
            aria-label="Close modal"
          >
            <HighlightOffIcon />
          </button>
        </div>

        {modalData.isLoading ? (
          <div className="flex justify-center py-8">
            <CircularProgress />
          </div>
        ) : (
          <>
            {renderContent()}
          </>
        )}
      </Box>
    </Modal >
  );
};

export default Dashboard;


